import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import PaginationCustom from "../../components/Pagination";
import { tripViolations } from "../../store/Slices/FuelSlice";
import "../../styles/Trip.css";
import { formatDate, formatString } from "../../utils/helper";
import SpinnerLoader from "../../utils/SpinnerLoader";
import { highIcon, lowIcon, mediumIcon, viewIcon } from "../../utils/svgs";

const severityClass = {
    high: "sev_high",
    medium: "sev_medium",
    low: "sev_low",
};

const severityIcon = {
    high: highIcon,
    medium: mediumIcon,
    low: lowIcon,
};

const FuelViolations = () => {
    const dispatch = useDispatch();
    const { id } = useParams();

    const [currentPage, setCurrentPage] = useState(1);
    const [limit, setLimit] = useState(10);

    const { tripViolationsData, tripViolationsLoading } = useSelector((state) => state.fuel);

    useEffect(() => {
        const data = {
            trip_id: id,
        }
        const params = {
            page: currentPage,
            limit: limit,
        }

        dispatch(tripViolations({ data, params }));
    }, [currentPage, limit])

    if (tripViolationsLoading) {
        return <SpinnerLoader />;
    }

    return (
        <div className="violations_wrap">
            <div className="violations_table_card" style={{ padding: "0px", border: "none" }}>
                <div className="violations_table">
                    <div className="violations_head fuel_log_history_head">
                        <span>Sr. No.</span>
                        <span>Type</span>
                        <span>Timestamp</span>
                        <span>Source</span>
                        <span>Severity</span>
                    </div>
                    {tripViolationsData?.results?.length === 0 && (
                        <div className="no_data_found">
                            <p>No Data Found</p>
                        </div>
                    )}
                    {tripViolationsData?.results?.map((row, index) => (
                        <div className="violations_row fuel_log_history_row" key={row.sr}>
                            <span>{(currentPage - 1) * limit + index + 1}</span>
                            <span>
                                <strong>{formatString(row.type)}</strong>
                                <br />
                                <small>{row.description}</small>
                            </span>
                            <span>{row.location}</span>
                            <span>{formatDate(row.occurred_at)}</span>
                            <span className={`severity_item ${severityClass[row.priority]}`}>
                                <span className="sev_icon">{severityIcon[row.priority]}</span>
                                <span>{row.priority}</span>
                            </span>
                        </div>
                    ))}

                    <PaginationCustom
                        className="violation_pagination"
                        totalItems={tripViolationsData?.meta?.totalItems}
                        totalPages={tripViolationsData?.meta?.totalPages}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                        limit={limit}
                        setLimit={setLimit}
                    />
                </div>
            </div>
        </div>
    );
};

export default FuelViolations;
